import type { TFunction } from "i18next";
import type { MotionAmplificationJob } from "../../clients/motion-amplification";
import type { JobView } from "../motion-amplification/types";

export function statusLabel(
  job: MotionAmplificationJob,
  t: TFunction,
  uploadState?: JobView["uploadState"],
) {
  if (uploadState === "uploading") {
    return t("motionAmplification.uploadingVideo");
  }
  if (uploadState === "starting") {
    return t("motionAmplification.startingProcessing");
  }

  return job.status === "Processing"
    ? job.phase || t("motionAmplification.processing")
    : job.status === "UploadPending"
      ? t("motionAmplification.uploadPending")
      : job.status === "Completed"
        ? t("motionAmplification.completed")
        : job.status === "Failed"
          ? t("motionAmplification.failed")
          : job.status;
}

function progressValue(value: number | string | null | undefined) {
  const number = Number(value);
  return Number.isFinite(number) ? number : 0;
}

export function actionLabel(label: string, progress?: number) {
  return progress === null || progress === undefined
    ? label
    : `${label} ${Math.round(progress)}%`;
}

export function getJobProgress(view: JobView) {
  return view.uploadState === "uploading"
    ? view.uploadProgress
    : progressValue(view.job.progressPercent);
}
